import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing }: Theme) {
    return {
        root: {
            position: 'absolute' as const,
            bottom: spacing(1),
            right: spacing(3),
        },
    };
}